/* ═══════════════════════════════════════════════════════════════════════
   PUPPA · Prueba en Casa — Vanilla JS booking flow
   Dawn Shopify theme compatible. No React, no Babel.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // ── data from Liquid ────────────────────────────────────────────────────
  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  var root = document.querySelector('[data-puppa-prueba]');
  if (!root) return;

  var MODELS   = readJson('puppa-models') || [];
  var SETTINGS = readJson('puppa-settings') || {};

  var WHATSAPP = (SETTINGS.whatsapp || '56965145485').replace(/[^\d]/g, '');
  var STORE    = SETTINGS.store || '/';
  var COMUNAS  = SETTINGS.comunas || [
    { value: '',            label: 'Selecciona tu comuna' },
    { value: 'providencia', label: 'Providencia' },
    { value: 'lascondes',   label: 'Las Condes' },
    { value: 'vitacura',    label: 'Vitacura' },
    { value: 'nunoa',       label: 'Ñuñoa' },
    { value: 'macul',       label: 'Macul' },
    { value: 'la-florida',  label: 'La Florida' },
    { value: 'lareina',     label: 'La Reina' },
    { value: 'penalolen',   label: 'Peñalolén' },
    { value: 'santiago',    label: 'Santiago Centro' },
    { value: 'otra',        label: 'Otra (RM)' }
  ];
  var TIMES = SETTINGS.times || ['09:00', '11:00', '13:00', '15:00', '17:00', '19:00', '21:00'];
  var DOWS  = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];
  var MONTHS = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

  // ── state ───────────────────────────────────────────────────────────────
  var state = {
    selected: [],
    date: '',
    time: '',
    blocked: [],
    name: '', phone: '', email: '', address: '', comuna: '',
    submitting: false,
    success: null,
    view: null,
    modalModel: null
  };

  // ── helpers ─────────────────────────────────────────────────────────────
  function $(sel, scope) { return (scope || root).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); }
  function fmtISO(d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + day;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }
  function capitalize(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

  // ── PRODUCT CARDS ───────────────────────────────────────────────────────
  function renderModels() {
    var grid = $('[data-models-grid]');
    if (!grid) return;
    grid.innerHTML = MODELS.map(function (m) {
      var sel = state.selected.indexOf(m.id) !== -1;
      var imgHTML = m.image
        ? '<img src="' + esc(m.image) + '" alt="' + esc(m.name) + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block;"/>'
        : '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:var(--tinta-soft);font-family:var(--font-serif);font-style:italic;font-size:14px;background:var(--crema-warm);">' + esc(m.name) + '</div>';
      return (
        '<div class="model-card ' + (sel ? 'selected' : '') + '" data-model-id="' + esc(m.id) + '" role="button" aria-pressed="' + sel + '">' +
          '<div class="model-img">' + imgHTML + '</div>' +
          '<div class="model-meta">' +
            '<div>' +
              '<div class="model-name">' + esc(m.name) + '</div>' +
              '<div class="model-age">' + esc(m.age) + '</div>' +
            '</div>' +
            '<button type="button" class="model-view" data-model-preview="' + esc(m.id) + '">Ver →</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    $$('[data-model-id]', grid).forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.hasAttribute('data-model-preview')) return;
        toggleModel(card.getAttribute('data-model-id'));
      });
    });
    $$('[data-model-preview]', grid).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        openModal(btn.getAttribute('data-model-preview'));
      });
    });

    var counter = $('[data-models-counter]');
    if (counter) {
      var n = state.selected.length;
      counter.innerHTML = n === 0
        ? '<span>Fija tus favoritos, pero no te preocupes, llevaremos nuestra colección completa, a donde quieras</span>'
        : '<span><strong>' + n + '</strong> modelo' + (n === 1 ? '' : 's') +
          ' seleccionado' + (n === 1 ? '' : 's') + ' · </span>';
    }
var cta = document.createElement('div');
    cta.style.cssText = 'text-align:center;margin-top:24px;';
    cta.innerHTML = '<a href="https://www.puppa.cl/collections/all" target="_blank" rel="noopener" class="btn-primary">Ver catálogo completo <span class="arrow">→</span></a>';
    grid.parentNode.insertBefore(cta, grid.nextSibling);

    updateStepCheckmark('models', state.selected.length > 0);
  }

  function toggleModel(id) {
    updateStepCheckmark('models', state.selected.length > 0);
  }

  function toggleModel(id) {
    var i = state.selected.indexOf(id);
    if (i === -1) {
      if (state.selected.length >= 6) return;
      state.selected.push(id);
    } else {
      state.selected.splice(i, 1);
    }
    renderModels();
    renderSummary();
  }

  function updateStepCheckmark(step, complete) {
    var sec = $('[data-step="' + step + '"]');
    if (!sec) return;
    sec.classList.toggle('is-complete', !!complete);
  }

  // ── CALENDAR ────────────────────────────────────────────────────────────
  function renderCalendar() {
    var mount = $('[data-calendar]');
    if (!mount) return;
    var today = new Date(); today.setHours(0,0,0,0);
    var tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
    if (!state.view) {
      state.view = { y: tomorrow.getFullYear(), m: tomorrow.getMonth() };
    }

    var first = new Date(state.view.y, state.view.m, 1);
    var last  = new Date(state.view.y, state.view.m + 1, 0);
    var startDow = (first.getDay() + 6) % 7;

    var canPrev = state.view.y > today.getFullYear() ||
                  (state.view.y === today.getFullYear() && state.view.m > today.getMonth());

    var html = '<div class="cal-head">' +
      '<button type="button" class="cal-nav" data-cal-prev ' + (canPrev ? '' : 'disabled') + ' aria-label="Mes anterior">‹</button>' +
      '<div class="cal-month">' + MONTHS[state.view.m] + ' ' + state.view.y + '</div>' +
      '<button type="button" class="cal-nav" data-cal-next aria-label="Mes siguiente">›</button>' +
    '</div>';

    html += '<div class="cal-grid">';
    DOWS.forEach(function (d) { html += '<div class="cal-dow">' + d + '</div>'; });
    for (var i = 0; i < startDow; i++) html += '<div></div>';
    for (var d = 1; d <= last.getDate(); d++) {
      var date = new Date(state.view.y, state.view.m, d);
      var iso = fmtISO(date);
      var past = date < tomorrow;
      var isToday = fmtISO(today) === iso;
      var isSel = state.date === iso;
      html += '<button type="button" class="cal-day ' +
        (isSel ? 'selected ' : '') + (isToday ? 'today' : '') + '" ' +
        'data-cal-day="' + iso + '" ' + (past ? 'disabled' : '') + '>' + d + '</button>';
    }
    html += '</div>';
    mount.innerHTML = html;

    var prevBtn = $('[data-cal-prev]', mount);
    var nextBtn = $('[data-cal-next]', mount);
    if (prevBtn) prevBtn.addEventListener('click', function () {
      if (state.view.m === 0) state.view = { y: state.view.y - 1, m: 11 };
      else state.view = { y: state.view.y, m: state.view.m - 1 };
      renderCalendar();
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (state.view.m === 11) state.view = { y: state.view.y + 1, m: 0 };
      else state.view = { y: state.view.y, m: state.view.m + 1 };
      renderCalendar();
    });
    $$('[data-cal-day]', mount).forEach(function (b) {
      b.addEventListener('click', function () {
        state.date = b.getAttribute('data-cal-day');
        updateBlocked();
        renderCalendar();
        renderTimes();
        renderSummary();
        updateStepCheckmarks();
      });
    });
  }

  function updateBlocked() {
    if (!state.date) { state.blocked = []; return; }
    var seed = state.date.split('-').reduce(function (a, b) { return a + parseInt(b, 10); }, 0);
    state.blocked = TIMES.filter(function (_, i) { return ((seed + i * 7) % 5) === 0; }).slice(0, 2);
    if (state.time && state.blocked.indexOf(state.time) !== -1) state.time = '';
  }

  function renderTimes() {
    var grid = $('[data-times]');
    var note = $('[data-times-note]');
    if (!grid) return;
    grid.innerHTML = TIMES.map(function (t) {
      var dis = !state.date || state.blocked.indexOf(t) !== -1;
      var sel = state.time === t;
      return '<button type="button" class="time-btn ' + (sel ? 'selected' : '') + '" ' +
             'data-time="' + t + '" ' + (dis ? 'disabled' : '') + '>' + t + '</button>';
    }).join('');
    $$('[data-time]', grid).forEach(function (b) {
      b.addEventListener('click', function () {
        state.time = b.getAttribute('data-time');
        renderTimes();
        renderSummary();
        updateStepCheckmarks();
      });
    });
    if (note) {
      note.innerHTML = state.date
        ? '☀ Las visitas duran ~30 minutos. Llegamos puntuales.'
        : 'Primero elige una fecha para ver los horarios.';
    }
  }

  function updateStepCheckmarks() {
    updateStepCheckmark('models', state.selected.length > 0);
    updateStepCheckmark('datetime', state.date && state.time);
    updateStepCheckmark('details', state.name && state.phone && state.address && state.comuna);
  }

  // ── DETAILS FORM ────────────────────────────────────────────────────────
  function bindDetails() {
    var sel = $('[data-field="comuna"]');
    if (sel) {
      sel.innerHTML = COMUNAS.map(function (c) {
        return '<option value="' + esc(c.value) + '">' + esc(c.label) + '</option>';
      }).join('');
    }
    ['name','phone','email','address','comuna'].forEach(function (k) {
      var el = $('[data-field="' + k + '"]');
      if (!el) return;
      var update = function () {
        state[k] = el.value;
        renderSummary();
        updateStepCheckmarks();
      };
      el.addEventListener('input', update);
      el.addEventListener('change', update);
    });
  }

  // ── SUMMARY ─────────────────────────────────────────────────────────────
  function renderSummary() {
    var s = $('[data-summary]');
    if (!s) return;

    var names = state.selected.map(function (id) {
      var m = MODELS.find(function (f) { return f.id === id; });
      return m ? m.name : '';
    }).filter(Boolean);

    var dateFmt = '';
    if (state.date) {
      var d = new Date(state.date + 'T00:00:00');
      dateFmt = d.toLocaleDateString('es-CL', { weekday:'long', day:'numeric', month:'long' });
      dateFmt = capitalize(dateFmt);
    }
    var comunaLabel = (COMUNAS.find(function (c) { return c.value === state.comuna; }) || {}).label || '';

    var fields = [
      !!state.date,
      !!state.time,
      !!state.name.trim(),
      !!state.phone.trim(),
      !!state.address.trim(),
      !!state.comuna
    ];
    var done = fields.filter(Boolean).length;
    var total = fields.length;
    var pct = Math.round((done / total) * 100);
    var valid = done === total;

    s.innerHTML =
      '<div class="summary-title">tu visita</div>' +
      '<div class="summary-h2">en casa, con un especialista</div>' +
      '<div class="summary-progress">' +
        '<div class="progress-bar"><div class="progress-fill" style="width:' + pct + '%;"></div></div>' +
        '<div class="progress-label"><span>' + done + '/' + total + ' completos</span><span>' + pct + '%</span></div>' +
      '</div>' +

      '<div class="summary-row">' +
        '<div class="summary-icon">▦</div>' +
        '<div>' +
          '<div class="summary-key">Fecha</div>' +
          '<div class="summary-val ' + (!dateFmt ? 'muted' : '') + '">' +
            (dateFmt ? esc(dateFmt) : 'Aún no eliges') +
          '</div>' +
        '</div>' +
      '</div>' +

      '<div class="summary-row">' +
        '<div class="summary-icon">◷</div>' +
        '<div>' +
          '<div class="summary-key">Hora</div>' +
          '<div class="summary-val ' + (!state.time ? 'muted' : '') + '">' +
            (state.time || 'Aún no eliges') +
          '</div>' +
        '</div>' +
      '</div>' +

      '<div class="summary-row">' +
        '<div class="summary-icon">◉</div>' +
        '<div>' +
          '<div class="summary-key">Dirección</div>' +
          '<div class="summary-val ' + (!state.address ? 'muted' : '') + '">' +
            (state.address
              ? esc(state.address) + (comunaLabel ? ', ' + esc(comunaLabel) : '')
              : 'Aún no la indicas') +
          '</div>' +
        '</div>' +
      '</div>' +

      '<button class="submit-btn" data-submit ' + (valid && !state.submitting ? '' : 'disabled') + '>' +
        (state.submitting ? 'Procesando…' : 'Confirmar por WhatsApp <span>→</span>') +
      '</button>' +
      '<div class="submit-foot">Te contactamos para confirmar la dirección.</div>';

    var btn = $('[data-submit]', s);
    if (btn) btn.addEventListener('click', submit);
  }

  // ── MODAL (product quick view) ──────────────────────────────────────────
  function openModal(id) {
    var m = MODELS.find(function (x) { return x.id === id; });
    if (!m) return;
    state.modalModel = m;
    renderModal();
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    state.modalModel = null;
    var bd = $('[data-modal]');
    if (bd) bd.classList.remove('open');
    document.body.style.overflow = '';
  }
  function renderModal() {
    var bd = $('[data-modal]');
    if (!bd) return;
    var m = state.modalModel;
    if (!m) { bd.classList.remove('open'); return; }
    var sel = state.selected.indexOf(m.id) !== -1;
    var imgHTML = m.image
      ? '<img src="' + esc(m.image) + '" alt="' + esc(m.name) + '" style="width:100%;height:100%;object-fit:cover;display:block;"/>'
      : '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:var(--tinta-soft);font-style:italic;">' + esc(m.name) + '</div>';
    var firstChar = m.name.charAt(0);
    var rest = m.name.slice(1);

    bd.innerHTML =
      '<div class="modal" data-modal-inner>' +
        '<button class="modal-close" data-modal-close aria-label="Cerrar">✕</button>' +
        '<div class="modal-img">' + imgHTML + '</div>' +
        '<div class="modal-content">' +
          (m.tag ? '<span class="modal-tag">' + esc(m.tag) + '</span>' : '') +
          '<h3>' + esc(firstChar) + '<span class="it">' + esc(rest) + '</span></h3>' +
          '<div class="modal-age">' + esc(m.age) + '</div>' +
          (m.desc ? '<p class="modal-desc">' + esc(m.desc) + '</p>' : '') +
          (m.specs && m.specs.length ?
            '<div class="modal-specs">' +
              m.specs.map(function (kv) {
                return '<div class="modal-spec"><span class="k">' + esc(kv[0]) + '</span><span class="v">' + esc(kv[1]) + '</span></div>';
              }).join('') +
            '</div>' : '') +
          (m.price ? '<div class="modal-price"><span class="from">Precio referencial</span>' + esc(m.price) + '</div>' : '') +
          '<div class="modal-actions">' +
            '<button class="modal-btn-primary ' + (sel ? 'selected' : '') + '" data-modal-toggle="' + esc(m.id) + '">' +
              (sel ? '✓ Agregado a la prueba' : 'Probarlo en casa') +
            '</button>' +
            '<a class="modal-btn-secondary" href="' + esc(m.url || (STORE + '/products/' + m.handle)) + '" target="_blank" rel="noopener">Ver en tienda →</a>' +
          '</div>' +
        '</div>' +
      '</div>';

    bd.classList.add('open');

    var inner = $('[data-modal-inner]', bd);
    inner.addEventListener('click', function (e) { e.stopPropagation(); });
    bd.addEventListener('click', closeModal);
    var closeBtn = $('[data-modal-close]', bd);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    var tog = $('[data-modal-toggle]', bd);
    if (tog) tog.addEventListener('click', function () {
      toggleModel(tog.getAttribute('data-modal-toggle'));
      closeModal();
    });
  }

  // ── CONFETTI ────────────────────────────────────────────────────────────
  function fireConfetti() {
    var colors = ['#3B5A3B', '#C79A2D', '#F2B9C8', '#25D366', '#FBF8F1'];
    var pieces = 80;
    for (var i = 0; i < pieces; i++) {
      var el = document.createElement('div');
      el.className = 'confetti-piece';
      el.style.background = colors[i % colors.length];
      el.style.left = Math.random() * 100 + 'vw';
      el.style.animationDelay = Math.random() * 0.4 + 's';
      el.style.animationDuration = (1.8 + Math.random() * 1.6) + 's';
      el.style.transform = 'rotate(' + (Math.random() * 360) + 'deg)';
      el.style.borderRadius = Math.random() > 0.5 ? '50%' : '2px';
      el.style.width = (6 + Math.random() * 8) + 'px';
      el.style.height = (8 + Math.random() * 10) + 'px';
      document.body.appendChild(el);
      (function (node) { setTimeout(function () { node.remove(); }, 4000); })(el);
    }
  }

  // ── SUBMIT ──────────────────────────────────────────────────────────────
  function isValid() {
    return state.date && state.time &&
           state.name.trim() && state.phone.trim() &&
           state.address.trim() && state.comuna;
  }

  function submit() {
    if (!isValid()) {
      showAlert('Por favor completa todos los campos requeridos.');
      window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
      return;
    }
    hideAlert();
    state.submitting = true;
    renderSummary();
    showLoading(true);

    persistToShopify();

    var modelNames = state.selected.map(function (id) {
      return (MODELS.find(function (f) { return f.id === id; }) || {}).name || '';
    }).filter(Boolean);
    var d = new Date(state.date + 'T00:00:00');
    var dateFmt = d.toLocaleDateString('es-CL', { weekday:'long', day:'numeric', month:'long' });
    var comunaLabel = (COMUNAS.find(function (c) { return c.value === state.comuna; }) || {}).label || state.comuna;

    var msg =
      '¡Hola Puppa! Quiero agendar una Prueba en Casa:\n\n' +
      '📅 ' + dateFmt + ' a las ' + state.time + '\n\n' +
      '👤 ' + state.name + '\n' +
      '📱 ' + state.phone + '\n' +
      (state.email ? '📧 ' + state.email + '\n' : '') +
      '📍 ' + state.address + ', ' + comunaLabel;

    var url = 'https://wa.me/' + WHATSAPP + '?text=' + encodeURIComponent(msg);

    setTimeout(function () {
      state.submitting = false;
      showLoading(false);
      state.success = { modelNames: modelNames, dateFmt: dateFmt, time: state.time, whatsappUrl: url };
      renderSuccess();
      setTimeout(fireConfetti, 100);
      setTimeout(fireConfetti, 600);
    }, 900);
  }

  function persistToShopify() {
    var form = $('[data-shopify-form]');
    if (!form) return;
    var modelNames = state.selected.map(function (id) {
      return (MODELS.find(function (f) { return f.id === id; }) || {}).name || '';
    }).filter(Boolean);
    var comunaLabel = (COMUNAS.find(function (c) { return c.value === state.comuna; }) || {}).label || state.comuna;

    var note =
      'PRUEBA EN CASA · ' + state.date + ' · ' + state.time + '\n' +
      'Modelos: ' + modelNames.join(', ') + '\n' +
      'Dirección: ' + state.address + ', ' + comunaLabel;

    setHidden('contact[first_name]', state.name);
    setHidden('contact[phone]', state.phone);
    setHidden('contact[email]', state.email || (state.phone.replace(/\D/g,'') + '@puppa.cl'));
    setHidden('contact[note]', note);
    setHidden('contact[tags]', 'prueba-en-casa,' + state.date);

    try {
      var fd = new FormData(form);
      fetch(form.action, { method: 'POST', body: fd, credentials: 'same-origin' })
        .catch(function () {});
    } catch (e) {}
  }
  function setHidden(name, value) {
    var input = root.querySelector('[data-shopify-form] [name="' + name + '"]');
    if (input) input.value = value || '';
  }

  // ── LOADING + ALERT ─────────────────────────────────────────────────────
  function showLoading(on) {
    var l = $('[data-loading]');
    if (l) l.classList.toggle('show', !!on);
  }
  function showAlert(msg) {
    var a = $('[data-alert]');
    if (!a) return;
    a.textContent = msg;
    a.classList.add('show');
  }
  function hideAlert() {
    var a = $('[data-alert]');
    if (a) a.classList.remove('show');
  }

  // ── SUCCESS ─────────────────────────────────────────────────────────────
  function renderSuccess() {
    var hero = $('[data-puppa-hero]');
    var how  = $('[data-puppa-how]');
    var bookGrid = $('[data-booking-grid]');
    var bookHead = $('[data-booking-head]');
    var successMount = $('[data-success]');

    if (hero) hero.style.display = 'none';
    if (how)  how.style.display = 'none';
    if (bookGrid) bookGrid.style.display = 'none';
    if (bookHead) bookHead.style.display = 'none';
    if (!successMount) return;

    successMount.innerHTML =
      '<div class="success-state show">' +
        '<div class="success-icon">✓</div>' +
        '<span class="eyebrow">¡todo listo!</span>' +
        '<h2 style="margin-top:12px;">Tu visita está <em style="color:var(--dorado);font-style:italic;">reservada</em></h2>' +
        '<p>Te abrimos WhatsApp para confirmar los últimos detalles.<br>' +
          '<strong>' + esc(state.success.modelNames.join(', ')) + '</strong> — ' +
          esc(state.success.dateFmt) + ' a las ' + esc(state.success.time) + '.</p>' +
        '<div style="display:flex;gap:12px;justify-content:center;flex-wrap:wrap;margin-top:8px;">' +
          '<a href="' + esc(state.success.whatsappUrl) + '" target="_blank" rel="noopener" class="btn-primary">' +
            'Abrir WhatsApp <span class="arrow">→</span>' +
          '</a>' +
          '<button data-reset class="btn-ghost" style="border:none;background:none;cursor:pointer;">Agendar otra visita</button>' +
        '</div>' +
      '</div>';
    successMount.style.display = 'block';
    window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });

    var reset = $('[data-reset]', successMount);
    if (reset) reset.addEventListener('click', function () {
      state.selected = [];
      state.date = ''; state.time = ''; state.blocked = [];
      state.name = state.phone = state.email = state.address = state.comuna = '';
      state.success = null;
      ['name','phone','email','address','comuna'].forEach(function (k) {
        var el = $('[data-field="' + k + '"]'); if (el) el.value = '';
      });
      successMount.style.display = 'none';
      successMount.innerHTML = '';
      if (hero) hero.style.display = '';
      if (how)  how.style.display = '';
      if (bookGrid) bookGrid.style.display = '';
      if (bookHead) bookHead.style.display = '';
      renderAll();
    });
  }

  // ── SCROLL REVEAL ───────────────────────────────────────────────────────
  function setupReveal() {
    var els = $$('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  // ── KEYBOARD ────────────────────────────────────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.modalModel) closeModal();
  });

  // ── RENDER ──────────────────────────────────────────────────────────────
  function renderAll() {
    renderModels();
    renderCalendar();
    renderTimes();
    renderSummary();
    updateStepCheckmarks();
  }

  function boot() {
    bindDetails();
    renderAll();
    setupReveal();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
